export default email => {
  const email_regex = /\S+@\S+\.\S+/;
  return email_regex.test(email)
}